// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class LinkDispatchCustomerToCompany {
  readonly companyId: string;
  readonly dispatchCustomerId: string;
  readonly isAutoLinked: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.companyId = data.companyId === undefined ? NIL_UUID : data.companyId;
    this.dispatchCustomerId =
      data.dispatchCustomerId === undefined ? NIL_UUID : data.dispatchCustomerId;
    this.isAutoLinked = data.isAutoLinked === undefined ? false : data.isAutoLinked;
  }

  static zero(): LinkDispatchCustomerToCompany {
    const zeroValues: ExcludeMethodsDeep<LinkDispatchCustomerToCompany> = {
      companyId: NIL_UUID,
      dispatchCustomerId: NIL_UUID,
      isAutoLinked: false,
    };
    return new LinkDispatchCustomerToCompany(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type LinkDispatchCustomerToCompanyWireFormat = {
  companyId: string;
  dispatchCustomerId: string;
  isAutoLinked: boolean;
};

type NewLinkDispatchCustomerToCompanyProps = PartialDeep<
  LinkDispatchCustomerToCompany,
  { recurseIntoArrays: true }
>;
export const NewLinkDispatchCustomerToCompany: (
  props: NewLinkDispatchCustomerToCompanyProps,
) => LinkDispatchCustomerToCompany = (props) => new LinkDispatchCustomerToCompany(props);

type NewLinkDispatchCustomerToCompanyFromWireFormatProps = PartialDeep<
  LinkDispatchCustomerToCompanyWireFormat,
  { recurseIntoArrays: true }
>;
export const NewLinkDispatchCustomerToCompanyFromWireFormat: (
  props: NewLinkDispatchCustomerToCompanyFromWireFormatProps,
) => LinkDispatchCustomerToCompany = (props) => new LinkDispatchCustomerToCompany(props);
